import React, { useState, useEffect } from 'react';
import logoSmall from '../Assets/Imgs/logos/Zeroz-Logo-Horizontal-Black.png';
import logoFull from '../Assets/Imgs/zeroz full logo.jpg';

import monsterEGirl from '../Assets/Imgs/MonsterEGirl.jpg';
import lolCurse from '../Assets/Imgs/Lol Curse.jpg';
import starKillLovers from '../Assets/Imgs/StarKillLoversSmall.jpg';
import dumbestTimelineCover from '../Assets/Imgs/The-Dumbest-Timeline-Album-Cover.jpg';
import ZerozRequiem from '../Assets/Imgs/Zeroz-Requiem.jpg';

import story_BG from '../Assets/Imgs/BandBG00.jpg';
import story_BG1 from '../Assets/Imgs/BandBG01.jpg';
import spotify from '../Assets/Imgs/spotify.png';
import youtube from '../Assets/Imgs/youtube.png';
import insta from '../Assets/Imgs/insta.jpg';
import tiktok from '../Assets/Imgs/tiktok2.png';
import appleMusic from '../Assets/Imgs/apple music.jpg';

import SongCard from '../Components/SongCard';

import MusicPlayer3D from '../Components/MusicPlayer3D';
import NavBar from '../Components/NavBar';
import Footer from '../Components/Footer';

function Main() {

  const [songChoiceName, setSongChoiceName] = useState('Zeroz Requiem');
  const [songChoiceLink, setSongChoiceLink] = useState('https://open.spotify.com/album/7z2BI1zU5ZhMRlpI4FGf8X');

  useEffect(()=>{
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const songValue = urlParams.get('song');

    if(songValue === 'starkilllovers'){
      setSongChoiceLink('https://open.spotify.com/track/4pRVbRjUTaeKlKOJK6HBXW?autoplay_ok=1')
      setSongChoiceName('Star Kill Lovers')
    }

    if(songValue === 'thedumbestsongnamepossible'){
      setSongChoiceLink('https://open.spotify.com/track/5v8uP4BQbU8d4N4ScPJq3B')
      setSongChoiceName('The Dumbest Song Name Possible')
    }

    console.log(songValue)

  }, [])

  return (
    <div className="App byAidanChristopherHaughey">
      <NavBar />
      <img src={logoFull} className="header-img" alt="header" />
      
      <div className="row" style={{marginTop:'-4px'}}>
        <div className="cardSongClassic" >
          <div className="img"><img src={ZerozRequiem} className="App-logo" alt="monster e girl" /></div>
          <div className="cardSongSubtitleClassic">
            <p>{songChoiceName}</p>
            <span>Album: ******</span>
          </div>
        </div>
        <div className="row cardSongLinkColumn songFeatureInfoRow" >
          <div className='column songFeatureColumn1'>
            <h3>{songChoiceName}, by Noise Star</h3>
            <a className="cardSongLinkClassic buttonPlay" href={songChoiceLink}>
              <img src={spotify} alt="spotify" className="icon invert" />
                Play
            </a>
            <a className='cardSongLinkClassic buttonPlay' href="https://music.apple.com/us/album/zeroz-requiem-single/6788332444">
              <img src={appleMusic} alt="spotify" className="icon" />
              Play
            </a>
            {songChoiceName === 'Zeroz Requiem' && <a className='cardSongLinkClassic buttonPlay' href="https://youtu.be/Qwl0llv79tU">
              <img src={youtube} alt="spotify" className="icon" />
              Play
            </a>
            }
          </div>
          <div className='column songFeatureColumn2'>
            <h1>{songChoiceName} is the newest single from Noise Star</h1>
          </div>
        </div>
      </div>
      
      <MusicPlayer3D />

      <div className="App-header story-header">
        <img src={story_BG} className="story-bg-img" />
        <div className="story-bg info-bg">
          <p className="blockWhite">Noise Star is a noisy anime inspired band.</p>
          <p className="blockWhite">Noise Star are goofy, always active, and fully dedicated to telling Noise Star story.</p>
          <p className="blockWhite">Noise Star releases music, music videos, hot-garbage, and sooooooon--a mobile app.</p>
          <p className="blockWhite">Hope you have a nice day!</p>
        </div>
      </div>
      <div className="Info-header">
        <img src={story_BG1} className="story-bg-img" />
        <div className="story-bg info-bg">
          <div className="headerFade">
            <p className="">No AI Policy</p>
          </div>
          <div className="row spaceAround">
            <p className="rowBlock blockWhite" >Noise Star absolutely forbids anyone from using Noise Star music in any and all AI training data & datasets.</p>
            <p className="rowBlock blockWhite" >Noise Star also refuses to use AI in any way shape or form in Noise Star art & music, including coding.</p>
          </div>
            <p className="letterSpacing infoContactHeader">Contact</p>
          <p className="blockWhite" style={{margin: 0}}>All of Noise Star is written and created by Aidan Christopher Haughey<br/> Email contact@noisestar.band for contact, or message on IG || Tik Tok</p>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Main;
